import { useId } from 'react';
import type { FieldError, UseFormRegisterReturn } from 'react-hook-form';

import { P } from '~components/Typography';
import { Input } from '~shared/ui/atoms';

import { Description, Error, Label, Wrapper } from './styles';

type Props = {
	registration: UseFormRegisterReturn;
	label?: string;
	placeholder?: string;
	width?: number;
	error?: FieldError['message'];
	description?: string;
	preventEnter?: boolean;
	autoFocus?: boolean;
	onBlur?: () => void;
};

export const TextField = ({
	registration,
	label,
	placeholder,
	width,
	error,
	description,
	preventEnter,
	autoFocus,
	onBlur,
}: Props) => {
	const id = useId();

	return (
		<Wrapper>
			{label && <Label htmlFor={id}>{label}</Label>}
			<Input
				id={id}
				aria-invalid={!!error}
				registration={registration}
				placeholder={placeholder}
				width={width}
				isError={!!error}
				preventEnter={preventEnter}
				autoFocus={autoFocus}
				onBlur={onBlur}
			/>
			{error ? (
				<Error>
					<P size="small" align="left" danger={true}>
						{error}
					</P>
				</Error>
			) : description ? (
				<Description>
					<P size="small" align="left" transparent={true}>
						{description}
					</P>
				</Description>
			) : null}
		</Wrapper>
	);
};
